import React, { useEffect, useState } from 'react';
import {
  Card, CardHeader, CardContent, Grid, TextField, Button,
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, TablePagination, IconButton, Snackbar, Dialog,
  DialogTitle, DialogContent, DialogActions, MenuItem, FormControl, Select, Box,
  Divider, Typography, Avatar, InputAdornment, CircularProgress
} from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import WorkIcon from '@mui/icons-material/Work';
import RefreshIcon from '@mui/icons-material/Refresh';
import axios from 'axios';
import Swal from 'sweetalert2';

const apiUrl = 'https://apidashboard.eurekagroup.id/designation';
const addUrl = `${apiUrl}/add`;
const editUrl = `${apiUrl}/edit`;
const deleteUrl = (id) => `${apiUrl}/delete/${id}`;

const DesignationDashPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [successPopup, setSuccessPopup] = useState(false);
  const [message, setMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [designationCode, setDesignationCode] = useState('');
  const [designationName, setDesignationName] = useState('');
  const [isActive, setIsActive] = useState(1);

  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        setLoading(true);
        const response = await axios.get(apiUrl);
        setData(response.data);
      } catch (error) {
        console.error('Error fetching designation data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchDesignations();
  }, []);

  const handleSearchChange = (event) => setSearchText(event.target.value);
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (designation) => {
    if (designation) {
      setSelectedDesignation(designation);
      setDesignationCode(designation.designation_code);
      setDesignationName(designation.designation_name);
      setIsActive(designation.is_active);
    } else {
      setSelectedDesignation(null);
      setDesignationCode('');
      setDesignationName('');
      setIsActive(1);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => setOpenDialog(false);

  const handleSaveDesignation = async () => {
    const designationData = { designation_code: designationCode, designation_name: designationName, is_active: isActive };
    const token = localStorage.getItem('token'); // Ambil token dari localStorage
  
    if (selectedDesignation) {
      // Jika mengedit designation
      try {
        await axios.put(
          editUrl,
          { ...designationData, id: selectedDesignation._id },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Tambahkan header Authorization
            },
          }
        );
        setData(data.map((des) => (des._id === selectedDesignation._id ? { ...des, ...designationData } : des)));
        setMessage('Designation updated successfully');
      } catch (error) {
        console.error('Error updating designation:', error.response?.data || error.message);
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.error || 'Failed to update designation',
          icon: 'error',
          confirmButtonText: 'Okay',
        });
      }
    } else {
      // Jika menambahkan designation baru
      try {
        const response = await axios.post(addUrl, designationData, {
          headers: {
            Authorization: `Bearer ${token}`, // Tambahkan header Authorization
          },
        });
        setData([...data, response.data]);
        setMessage('Designation added successfully');
      } catch (error) {
        console.error('Error adding designation:', error.response?.data || error.message);
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.error || 'Failed to add designation',
          icon: 'error',
          confirmButtonText: 'Okay',
        });
      }
    }
  
    setSuccessPopup(true);
    handleCloseDialog();
  };  

  const handleDeleteClick = async (id) => {
    const token = localStorage.getItem('token'); // Ambil token dari localStorage
  
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    });
  
    if (result.isConfirmed) {
      try {
        await axios.delete(deleteUrl(id), {
          headers: {
            Authorization: `Bearer ${token}`, // Tambahkan header Authorization
          },
        });
        setData(data.filter((des) => des._id !== id));
        setMessage('Designation deleted successfully');
        setSuccessPopup(true);
      } catch (error) {
        console.error('Error deleting designation:', error.response?.data || error.message);
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.error || 'Failed to delete designation',
          icon: 'error',
          confirmButtonText: 'Okay',
        });
      }
    }
  };  

  const filteredData = data.filter((des) => des.designation_name.toLowerCase().includes(searchText.toLowerCase()));

  return (
    <>
    <div className="animate-fade-in">
      <Card sx={{ boxShadow: '0 8px 32px rgba(0,0,0,0.1)', borderRadius: 3 }}>
            <CardHeader
              title={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }} className="shadow-lg">
                <WorkIcon />
              </Avatar>
                  <Box>
                <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary' }} className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  Manajemen Jabatan
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }} className="text-gray-600">
                  Kelola data jabatan dengan mudah dan efisien
                </Typography>
                  </Box>
                </Box>
              }
        action={
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button 
              variant="outlined" 
              color="primary" 
              startIcon={<RefreshIcon />} 
              onClick={() => window.location.reload()}
              disabled={loading}
              sx={{ 
                borderRadius: 2,
                px: 2,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              {loading ? <CircularProgress size={20} /> : 'Refresh'}
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              startIcon={<AddIcon />} 
              onClick={() => handleOpenDialog(null)}
              className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
              sx={{ 
                borderRadius: 2,
                px: 3,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': {
                  transform: 'translateY(-2px)'
                }
              }}
            >
              ✨ Tambah Jabatan
            </Button>
          </Box>
        }
        sx={{ pb: 2 }}
      />
      <Divider />
            <CardContent>
        {/* Filter Section */}
        <Box sx={{ 
          mb: 3, 
          p: 3, 
          bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover', 
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'grey.200'
        }} className="bg-gradient-to-r from-gray-50 to-blue-50 border-gray-200 shadow-sm animate-slide-up">
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Cari Jabatan"
                variant="outlined"
                value={searchText}
                onChange={handleSearchChange}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    bgcolor: (theme) => theme.palette.background.paper
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main' }}>
                  {filteredData.length}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Total Jabatan
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Table Section */}
        <Box sx={{ 
          border: '1px solid',
          borderColor: 'grey.200',
          borderRadius: 2,
          overflow: 'hidden'
        }}>
          {loading ? (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: 400,
              flexDirection: 'column',
              gap: 2
            }}>
              <CircularProgress size={60} />
              <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                Memuat data jabatan...
              </Typography>
            </Box>
          ) : (
            <>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ 
                        bgcolor: 'primary.main', 
                        color: 'white', 
                        fontWeight: 600,
                        fontSize: '0.875rem'
                      }}>
                        No
                      </TableCell>
                      <TableCell sx={{ 
                        bgcolor: 'primary.main', 
                        color: 'white', 
                        fontWeight: 600,
                        fontSize: '0.875rem'
                      }}>
                        Kode Jabatan
                      </TableCell>
                      <TableCell sx={{ 
                        bgcolor: 'primary.main', 
                        color: 'white', 
                        fontWeight: 600,
                        fontSize: '0.875rem'
                      }}>
                        Nama Jabatan
                      </TableCell>
                      <TableCell sx={{ 
                        bgcolor: 'primary.main', 
                        color: 'white', 
                        fontWeight: 600,
                        fontSize: '0.875rem'
                      }}>
                        Status
                      </TableCell>
                      <TableCell sx={{ 
                        bgcolor: 'primary.main', 
                        color: 'white', 
                        fontWeight: 600,
                        fontSize: '0.875rem',
                        textAlign: 'center'
                      }}>
                        Aksi
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((des, index) => (
                      <TableRow 
                        key={des._id}
                        sx={{ 
                          '&:hover': { 
                            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover',
                            transform: 'scale(1.001)',
                            transition: 'all 0.2s ease'
                          },
                          '&:nth-of-type(even)': {
                            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'action.hover'
                          }
                        }}
                      >
                        <TableCell sx={{ fontWeight: 500 }}>
                          {index + 1 + page * rowsPerPage}
                        </TableCell>
                        <TableCell>
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                            {des.designation_code}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {des.designation_name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ 
                            display: 'inline-block',
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 1,
                            bgcolor: des.is_active === 1 ? 'success.light' : 'error.light',
                            color: des.is_active === 1 ? 'success.dark' : 'error.dark',
                            fontSize: '0.75rem',
                            fontWeight: 600
                          }}>
                            {des.is_active === 1 ? 'Aktif' : 'Tidak Aktif'}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            <IconButton 
                              onClick={() => handleOpenDialog(des)} 
                              sx={{ 
                                color: 'info.main',
                                '&:hover': { 
                                  bgcolor: 'info.light',
                                  color: 'white',
                                  transform: 'scale(1.1)'
                                },
                                transition: 'all 0.2s ease'
                              }}
                              size="small"
                            >
                              <EditIcon fontSize="small" />
                          </IconButton>
                            <IconButton 
                              onClick={() => handleDeleteClick(des._id)} 
                              sx={{ 
                                color: 'error.main',
                                '&:hover': { 
                                  bgcolor: 'error.light',
                                  color: 'white',
                                  transform: 'scale(1.1)'
                                },
                                transition: 'all 0.2s ease'
                              }}
                              size="small"
                            >
                              <DeleteIcon fontSize="small" />
                          </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

                <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  borderTop: '1px solid',
                  borderColor: 'grey.200',
                  bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover'
                }}
                />
            </>
          )}
              </Box>
            </CardContent>
          </Card>
    </div>

      <Snackbar open={successPopup} autoHideDuration={6000} onClose={() => setSuccessPopup(false)} message={message} />

      <Dialog open={openDialog} onClose={() => {} }>
        <DialogTitle>{selectedDesignation ? 'Edit Designation' : 'Add Designation'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Designation Code"
            type="text"
            fullWidth
            variant="outlined"
            value={designationCode}
            onChange={(e) => setDesignationCode(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Designation Name"
            type="text"
            fullWidth
            variant="outlined"
            value={designationName}
            onChange={(e) => setDesignationName(e.target.value)}
          />
          <FormControl fullWidth margin="dense">
            <Select value={isActive} onChange={(e) => setIsActive(e.target.value)}>
              <MenuItem value={1}>Active</MenuItem>
              <MenuItem value={0}>Inactive</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Cancel</Button>
          <Button onClick={handleSaveDesignation} color="primary">Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DesignationDashPage;